import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const currentDate = dayjs().format("YYYY-MM-DD");
const currentTime = dayjs().format("hh:mm A");

const ValidDate: (date: any) => string = (date) => {
  if (date && dayjs(date).isValid() && typeof date == "string") {
    const dateArr = date?.split(".");
    if (dateArr.length > 0) return dateArr[0];
    else return date;
  } else return "";
};

export const ValidTime: (time: any) => string = (time) => {
  if (
    time &&
    typeof time === "string" &&
    dayjs(time, "hh:mm A", true).isValid()
  ) {
    return time;
  } else return "";
};

const ToLocalDate: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format("YYYY-MM-DD");
  else return "";
};

const ToLocalDateTime: (data: any) => string = (data) => {
  const valid = ValidDate(data);
  if (valid) return dayjs(valid).format("YYYY-MM-DD, hh:mm A");
  else return "";
};

const CalculateDuration: (start: string, end: string) => number = (
  start,
  end
) => {
  if (ValidDate(start) && ValidDate(end)) {
    const startDate = dayjs(start);
    const endDate = dayjs(end);
    const diff = endDate.diff(startDate, "minutes");
    return diff ? diff : 0;
  } else return 0;
};

export const CalculateTimeDuration: (start: string, end: string) => number = (
  start,
  end
) => {
  if (ValidTime(start) && ValidTime(end)) {
    const startTime = dayjs(start, "hh:mm A");
    const endTime = dayjs(end, "hh:mm A");
    const diff = endTime.diff(startTime, "minutes");
    return diff || 0;
  } else return 0;
};

const DateTime = {
  ValidDate,
  ValidTime,
  ToLocalDate,
  CalculateDuration,
  ToLocalDateTime,
  CalculateTimeDuration,
  currentDate,
  currentTime,
};

export default DateTime;
